export default (() => {
	window.Map.prototype.toObjectArray = function(props = []) {
		if (props.length > 0) {
			const values = Array.from(this.keys());
			return Array.from(this.values()).map((option, index) => {
				const constr = {};
				props.forEach(prop => {
					switch (prop) {
						case "value":
							constr[prop] = values[index];
							return;
						default:
							constr[prop] = option[prop];
							return;
					}
				});
				return constr;
			});
		} else {
			return Array.from(this.keys());
		}
	}	
})();